var escape = require("./node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500);", ""]);

// module
exports.push([module.id, "@font-face{font-family:Futura;src:url(" + escape(require("../app/assets/fonts/FuturaLT-Light.ttf")) + ") format(\"truetype\");font-weight:100}@font-face{font-family:Futura;src:url(" + escape(require("../app/assets/fonts/FuturaLT.ttf")) + ") format(\"truetype\");font-weight:300}@font-face{font-family:Futura;src:url(" + escape(require("../app/assets/fonts/FuturaLT-Heavy.ttf")) + ") format(\"truetype\");font-weight:500}@font-face{font-family:Futura;src:url(" + escape(require("../app/assets/fonts/FuturaLT-Bold.ttf")) + ") format(\"truetype\");font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?sourceMap!./main.scss
// module id = 423
// module chunks = 0